import { MgnlTemplateAnnotations } from '@/types';
import { MgnlContent } from '@/types/MgnlContent';

export function generateMissingAreas(
  content?: MgnlContent | null,
  templateAnnotations?: MgnlTemplateAnnotations | null
): MgnlContent | null | undefined {
  if (!content || !templateAnnotations) {
    return content;
  }

  const decoratedContent = JSON.parse(JSON.stringify(content)) as MgnlContent;
  Object.keys(templateAnnotations).forEach(key => {
    if (
      key.includes(content?.['@path']) &&
      templateAnnotations[key].startsWith('cms:area')
    ) {
      const areaName: string | undefined = key.split('/').pop();
      if (areaName && !(areaName in content)) {
        decoratedContent[areaName] = {
          '@path': `${content?.['@path']}/${areaName}`,
          '@nodes': [],
          '@id': `${content?.['@path']}/${areaName}`,
        };
      }
    }
  });
  return decoratedContent;
}
